// components/Layout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  return (
    <div className="main-content">
      <Sidebar />
      {/* Main Content */}
      <main className="page-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;